<template>
  <Modal
    :show="show.templateUnsaved"
    width="medium"
    @close="handleStay"
  >
    <template #title>
      Unsaved changes
    </template>

    <template #content>
      You have unsaved changes. Leave without saving?
    </template>

    <template #actions>
      <v-btn
        variant="outlined"
        size="small"
        rounded="lg"
        class="text-button-2"
        @click="handleStay"
      >
        Stay
      </v-btn>

      <v-spacer />

      <v-btn
        variant="outlined"
        color="error"
        size="small"
        rounded="lg"
        class="text-button-2 mr-2"
        @click="handleDiscard"
      >
        Discard & leave
      </v-btn>

      <v-btn
        variant="flat"
        color="primary"
        size="small"
        rounded="lg"
        class="text-button-2"
        @click="handleSaveAndSwitch"
      >
        Save & leave
      </v-btn>
    </template>
  </Modal>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useModals } from '@/stores/modals/modals';
import Modal from '@/components/shared/Modal.vue';

defineOptions({ name: 'TemplateUnsavedModal' });

const emit = defineEmits(['stay', 'discard', 'save-and-switch']);

const { show } = storeToRefs(useModals());
const { setModal } = useModals();

const close = () => setModal({ field: 'templateUnsaved', value: false });

const handleStay = () => {
  close();
  emit('stay');
};

const handleDiscard = () => {
  close();
  emit('discard');
};

const handleSaveAndSwitch = () => {
  close();
  emit('save-and-switch');
};
</script>
